import moment from 'moment';

export default function toDate(value, time = false) {
    if(!value) return null;
    const format = time ? "MM/DD/YYYY hh:mm a":"MM/DD/YYYY"; 
    var formatedDate = moment(value).format(format);
    return formatedDate;
}
